<template lang='pug'>
  div
    v-container(fluid, grid-list-xl)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-text
              div(class="loading" v-show="loading")
                v-progress-circular(color="primary" indeterminate :size="80")
              u-form(v-model="resultForm" :id='form.key' :json='formComponent')
</template>

<script>
import _ from 'lodash'
import {mapState, mapGetters} from 'vuex'
import axios from 'axios'

import UForm from '@/components/form/form'
import {db} from '@/store/firebase'
import apiGestation from '@/api/gestation'

export default {
  name: 'uf-form',

  components: {
    UForm
  },

  computed: {
    ...mapState({
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction,
      gestation: (state) => state.ultraFetal.gestation,
      user: (state) => state.user
    }),
    ...mapGetters('formCustomization', ['getCustomizedForms', 'getFormByKey']),
    forms () {
      return this.getCustomizedForms
    },
    form () {
      return this.getFormByKey('conclusion')
    },
    formComponent () {
      if (!this.form) {
        return null
      }
      let component = this.form.components[0]
      if (this.user.enabledIA) {
        component.fillTemplate = this.fillTemplate
        component.suggestConclusion = this.suggestConclusion
      }
      return component
    }
  },

  watch: {
    resultForm: {
      handler: function (val) {
        this.save()
      },
      deep: true
    },
    'gestationInteraction.forms' (val) {
      if (!_.isEqual(val, this.resultForm)) {
        this.resultForm = val
      }
    }
  },

  data () {
    return {
      msg: 'uf-form',
      tabActive: 0,
      loading: false,
      resultForm: null
    }
  },

  mounted () {
    this.resultForm = Object.assign({}, this.gestationInteraction.forms)
  },

  methods: {
    save: _.debounce(function () {
      let form = this.resultForm
      Object.entries(form).forEach(([key, value]) => {
        if ([undefined, null, ''].indexOf(value) > -1) delete form[key]
      })
      db.doc('gestationInteraction/' + this.gestationInteraction.iuid).update({forms: form})
    }, 1000),
    fillTemplate: async function (template) {
      try {
        this.loading = true
        const payload = {id: this.gestationInteraction.iuid, template}
        const url = 'https://natalia-api-197582994272.southamerica-east1.run.app/fill-template'
        const response = await axios.post(url, payload)
        if (!response || !response.data) {
          return template
        }
        return response.data.conclusion
      } catch (e) {
        console.log('template error : ', e)
        return template
      } finally {
        this.loading = false
      }
    },
    suggestConclusion: async function () {
      try {
        this.loading = true
        const previusStudyIds = await apiGestation.getGestationInteractions(this.gestation.iuid)
        previusStudyIds.splice(previusStudyIds.indexOf(this.gestationInteraction.iuid), 1)
        let lastDoctorStudyIds = []
        if (this.gestationInteraction.doctor) {
          lastDoctorStudyIds = await apiGestation.getGestationInteractionsByDoctor(this.gestationInteraction.doctor.id)
        }
        const payload = {id: this.gestationInteraction.iuid, previusStudyIds, lastDoctorStudyIds}
        const url = 'https://natalia-api-197582994272.southamerica-east1.run.app/suggest-conclusion'
        const response = await axios.post(url, payload)
        if (!response || !response.data) {
          throw Error('sem resposta da aplicação')
        }
        return response.data.conclusion
      } catch (e) {
        console.log('error : ', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Conclusion.vue